import { create } from "zustand";
import { getS3BaseUrl } from "../config/environment";

export const useModelStore = create((set, get) => ({
  models: [],
  setModels: (models) => set({ models }),

  selectedUUIDs: new Set(),
  setSelectedUUIDs: (uuids) => set({ selectedUUIDs: new Set([...uuids]) }),

  selectedMeshes: [], // NOT persisted
  setSelectedMeshes: (meshes) => set({ selectedMeshes: meshes }),

  pendingSelectionId: null, // model ID to auto-select once its mesh loads
  setPendingSelectionId: (id) => set({ pendingSelectionId: id }),

  cameraControls: null, // NOT persisted
  setCameraControls: (controls) => set({ cameraControls: controls }),

  baseModelUrl: `${getS3BaseUrl()}/template/object/`,

  availableModels: [
    "chair/chair1",
    "chair/chair2",
    "chair/chair3",
    // "Couch_scaled",
    // "Lamp_scaled",
    // "Plant_scaled",
    // "Table",
  ],

  meshMap: new Map(), // NOT persisted
  addMeshMap: (id, map) => {
    const newMap = new Map(get().meshMap);
    map.forEach((v, k) => newMap.set(k, v));
    set({ meshMap: newMap });
  },

  removeMeshMapById: (id) => {
    const newMap = new Map();
    for (const [uuid, mesh] of get().meshMap) {
      if (mesh.userData.sourceId !== id) newMap.set(uuid, mesh);
    }
    set({ meshMap: newMap });
  },
}));
